module.exports = __webpack_public_path__ + "img/DIRECTOR_REJECTED.fbd402f4.svg";